import { DonutChart } from '@tremor/react'
import { TrendingUp, TrendingDown, ArrowRight } from 'lucide-react'
import type { TrendDirectionSummary as TrendData } from './types'

interface Props {
  data: TrendData
}

export function TrendDirectionSummary({ data }: Props) {
  const chartData = [
    { name: 'Improving', value: data.improving.count },
    { name: 'Stable', value: data.stable.count },
    { name: 'Declining', value: data.declining.count },
  ]

  if (data.total === 0) {
    return (
      <div className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900/50 p-5">
        <h3 className="font-medium text-stone-900 dark:text-stone-100">Trend Direction Summary</h3>
        <div className="h-48 flex items-center justify-center text-sm text-stone-500 dark:text-stone-400">
          No trend data available for the selected period
        </div>
      </div>
    )
  }

  return (
    <div className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900/50 p-5">
      <h3 className="font-medium text-stone-900 dark:text-stone-100">Trend Direction Summary</h3>
      <p className="text-xs text-stone-500 dark:text-stone-400 mt-1">
        Distribution of question answer trends across {data.total} data points
      </p>

      <div className="mt-6 flex flex-col lg:flex-row items-center gap-8">
        <DonutChart
          className="h-40 w-40"
          data={chartData}
          category="value"
          index="name"
          colors={['emerald', 'stone', 'amber']}
          showAnimation
          showLabel={false}
        />

        <div className="flex-1 grid grid-cols-3 gap-4 w-full">
          <div className="text-center p-4 rounded-lg bg-emerald-50 dark:bg-emerald-950/40">
            <TrendingUp className="w-5 h-5 text-emerald-600 mx-auto mb-2" />
            <div className="text-xl font-semibold text-emerald-700 dark:text-emerald-400">
              {data.improving.percentage}%
            </div>
            <div className="text-xs text-emerald-600 dark:text-emerald-400">
              Improving ({data.improving.count})
            </div>
          </div>

          <div className="text-center p-4 rounded-lg bg-stone-100 dark:bg-stone-800">
            <ArrowRight className="w-5 h-5 text-stone-500 mx-auto mb-2" />
            <div className="text-xl font-semibold text-stone-700 dark:text-stone-300">
              {data.stable.percentage}%
            </div>
            <div className="text-xs text-stone-500 dark:text-stone-400">
              Stable ({data.stable.count})
            </div>
          </div>

          <div className="text-center p-4 rounded-lg bg-amber-50 dark:bg-amber-950/40">
            <TrendingDown className="w-5 h-5 text-amber-600 mx-auto mb-2" />
            <div className="text-xl font-semibold text-amber-700 dark:text-amber-400">
              {data.declining.percentage}%
            </div>
            <div className="text-xs text-amber-600 dark:text-amber-400">
              Declining ({data.declining.count})
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
